document.addEventListener("DOMContentLoaded", () => {
	const body = document.querySelector('body');
	const toggleButtons = document.querySelectorAll('.toggle-button');
	const drawers = Array.from(document.querySelectorAll('.drawer'));

	function toggleDrawer(event) {
		let targetDrawer = document.querySelector(`#${event.target.dataset.target}`);
		let currentButton = event.target;

		// close any open drawers and remove 'open' class from buttons
		drawers.forEach(drawer => {
			if(drawer !== targetDrawer && drawer.classList.contains("open")) {
				drawer.classList.remove("open");
			}
		});
		toggleButtons.forEach(button => {
			if(button !== currentButton && button.classList.contains("open")) {
				button.classList.remove("open");
			}
		});

		// toggle 'open' class on the target drawer and button
		targetDrawer.classList.toggle("open");
		currentButton.classList.toggle("open");

		// toggle 'fixed' class on the body element
		if (drawers.some(drawer => drawer.classList.contains("open"))) {
			body.classList.add("fixed");
		} else {
			body.classList.remove("fixed");
		}
	}
	toggleButtons.forEach(button => button.addEventListener('click', toggleDrawer));
});
 